/** Accept text, and return React JSX that preserves the spacing and newlines of the string. */
export const multiline = (string: string): React.ReactNode[] => {
  const lines = string.split(/\r?\n/);
  const parts = [] as React.ReactNode[];
  for (let i = 0; i < lines.length; i++) {
    if (i) parts.push(<br key={i} />);
    parts.push(lines[i].replace(/ {2}/g, "\xa0 ").replace(/^ /, "\xa0"));
  }
  return parts;
};
